import { AuthService } from '../msal'

const API_BASE = process.env.NODE_ENV==='production' ? '/api' : 'http://localhost:5000/api'

async function getAuthHeader(debug=false) {
    let accessTokenResponse = await AuthService.getApiAccessTokenRedirect()
    if (debug) console.log(accessTokenResponse)
    return {
        Authorization: `Bearer ${accessTokenResponse.accessToken}`
    }
}

export async function get(path) {
    let url = API_BASE+path
    let authHeader = await getAuthHeader()
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            ...authHeader
        }
    })
    return response.json()
}

export async function post(path, data) {
    let url = API_BASE+path
    let authHeader = await getAuthHeader(true)
    const response = await fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
            ...authHeader   ,
            'Content-type': 'application/json',
        },
        body: JSON.stringify(data),
    })
    return response.json()
}